module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('find-stats'), _vm._v(" "), (_vm.page === _vm.PAGE_UNSUPPORTED) ? _c('find-modal', [_c('find-unsupported')], 1) : _vm._e(), _vm._v(" "), (_vm.page === _vm.PAGE_WELCOME) ? _c('find-modal', [_c('find-welcome')], 1) : _vm._e(), _vm._v(" "), (_vm.page === _vm.PAGE_CONGRATULATIONS) ? _c('find-modal', {
    attrs: {
      "wide": ""
    }
  }, [_c('find-congratulations')], 1) : _vm._e(), _vm._v(" "), (_vm.page === _vm.PAGE_GAME) ? _c('find-game') : _vm._e(), _vm._v(" "), _c('find-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e229cc36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 168
// module chunks = 2